import TabPanel, {Tab} from '../../components/TabPanel'
import CreateIAMRoleCLI from './_03_create_iam_role_cli.mdx'
import CreateIAMRoleConsole from './_03_create_iam_role_console.mdx'

### Create IAM role

Next, you need to create an IAM role using the policy just created.

<TabPanel>
  <Tab id="cli" label="CLI" textContent>
    <CreateIAMRoleCLI />
  </Tab>
  <Tab id="console" label="console" textContent>
    <CreateIAMRoleConsole />
  </Tab>
</TabPanel>
